{
  "profiles": [
    {
      "id": "duty-officer",
      "label": {
        "en": "Duty officer",
        "ar": "الضابط المناوب"
      },
      "roles": [
        "case-supervisor",
        "case-worker"
      ],
      "default_agent": "moi-duty-officer",
      "work_lists": [
        {
          "id": "court-orders",
          "label": {
            "en": "Court orders pending at my station",
            "ar": "الأوامر القضائية المعلّقة في مركزي"
          },
          "source": "tool",
          "call": {
            "tool": "moi",
            "action": "list_court_orders",
            "args": {
              "station": "{user.unit}",
              "status": "pending"
            }
          },
          "agent": "moi-judicial-orders",
          "open": "record",
          "record": {
            "type": "court_order",
            "field": "order_no"
          },
          "item_label": "{order_no} · {name_en}"
        },
        {
          "id": "my-approvals",
          "label": {
            "en": "Waiting for my approval",
            "ar": "بانتظار اعتمادي"
          },
          "source": "inbox",
          "filter": {
            "kind": "approval"
          },
          "open": "task"
        },
        {
          "id": "my-reports",
          "label": {
            "en": "My open reports",
            "ar": "بلاغاتي المفتوحة"
          },
          "source": "cases",
          "filter": {
            "status": "open"
          },
          "agent": "moi-case-status",
          "input": {
            "case_id": "{item.id}"
          }
        }
      ],
      "record_types": [
        {
          "type": "person",
          "label": {
            "en": "Person",
            "ar": "شخص"
          },
          "key": "emirates_id",
          "lookup": {
            "tool": "moi",
            "action": "get_person",
            "arg": "emirates_id",
            "agent": "moi-person-check"
          },
          "related": [
            {
              "tool": "moi",
              "action": "search_wanted",
              "arg": "emirates_id",
              "label": {
                "en": "Wanted lists",
                "ar": "قوائم المطلوبين"
              },
              "agent": "moi-wanted-check"
            },
            {
              "tool": "moi",
              "action": "custody_status",
              "arg": "emirates_id",
              "label": {
                "en": "Custody",
                "ar": "التوقيف"
              },
              "agent": "moi-custody-status"
            }
          ],
          "actions": [
            "request-detention",
            "open-court-file"
          ],
          "purpose_required": true
        },
        {
          "type": "court_order",
          "label": {
            "en": "Court order",
            "ar": "أمر قضائي"
          },
          "key": "order_no",
          "lookup": {
            "tool": "moi",
            "action": "list_court_orders",
            "arg": "order_no",
            "agent": "moi-judicial-orders"
          },
          "related": [],
          "actions": [
            "execute-order"
          ]
        },
        {
          "type": "case",
          "label": {
            "en": "Criminal case",
            "ar": "قضية جنائية"
          },
          "key": "case_no",
          "lookup": {
            "tool": "moi",
            "action": "case_file",
            "arg": "case_no",
            "agent": "moi-case-qa",
            "question": {
              "en": "Show the case file {record.key}",
              "ar": "اعرض ملف القضية {record.key}"
            }
          },
          "related": [],
          "actions": [
            "open-court-file"
          ],
          "purpose_required": true,
          "workspace": {
            "sections": [
              {
                "id": "overview",
                "label": {
                  "en": "Overview",
                  "ar": "نظرة عامة"
                },
                "source": "lookup",
                "kind": "fields"
              },
              {
                "id": "people",
                "label": {
                  "en": "People",
                  "ar": "الأشخاص"
                },
                "source": "part:parties",
                "kind": "people",
                "open": {
                  "type": "person",
                  "field": "emirates_id"
                }
              },
              {
                "id": "timeline",
                "label": {
                  "en": "Timeline",
                  "ar": "التسلسل الزمني"
                },
                "source": "part:timeline",
                "kind": "timeline"
              },
              {
                "id": "evidence",
                "label": {
                  "en": "Evidence",
                  "ar": "الأدلة"
                },
                "source": "part:evidence",
                "kind": "documents",
                "document": {
                  "tool": "moi",
                  "action": "get_document",
                  "arg": "id",
                  "agent": "moi-case-qa",
                  "field": "id"
                }
              },
              {
                "id": "map",
                "label": {
                  "en": "Map",
                  "ar": "الخريطة"
                },
                "source": "part:locations",
                "kind": "map"
              },
              {
                "id": "links",
                "label": {
                  "en": "Links",
                  "ar": "الروابط"
                },
                "source": "part:links",
                "kind": "network"
              },
              {
                "id": "related",
                "label": {
                  "en": "Related cases",
                  "ar": "قضايا مرتبطة"
                },
                "source": "part:related_cases",
                "kind": "table",
                "open": {
                  "type": "case",
                  "field": "case_no"
                }
              }
            ],
            "analyses": [
              {
                "id": "summary",
                "label": {
                  "en": "Summary",
                  "ar": "ملخص"
                },
                "agent": "moi-case-summary",
                "input": {
                  "case_no": "{record.key}"
                },
                "question": {
                  "en": "Summarise case {record.key}",
                  "ar": "لخّص القضية {record.key}"
                }
              },
              {
                "id": "court-ready",
                "label": {
                  "en": "Ready for court?",
                  "ar": "جاهزة للمحكمة؟"
                },
                "agent": "moi-court-readiness",
                "input": {
                  "case_no": "{record.key}"
                },
                "question": {
                  "en": "Is case {record.key} ready for court? What is missing?",
                  "ar": "هل القضية {record.key} جاهزة للمحكمة؟ ما الناقص؟"
                }
              },
              {
                "id": "timeline",
                "label": {
                  "en": "Timeline",
                  "ar": "التسلسل الزمني"
                },
                "agent": "moi-case-timeline",
                "input": {
                  "case_no": "{record.key}"
                },
                "question": {
                  "en": "Build the timeline of case {record.key}",
                  "ar": "ابنِ التسلسل الزمني للقضية {record.key}"
                }
              },
              {
                "id": "contradictions",
                "label": {
                  "en": "Contradictions",
                  "ar": "التناقضات"
                },
                "agent": "moi-contradictions",
                "input": {
                  "case_no": "{record.key}"
                },
                "question": {
                  "en": "Find contradictions between the statements and evidence in case {record.key}",
                  "ar": "ابحث عن التناقضات بين الإفادات والأدلة في القضية {record.key}"
                }
              },
              {
                "id": "links",
                "label": {
                  "en": "Links",
                  "ar": "الروابط"
                },
                "agent": "moi-link-analysis",
                "input": {
                  "case_no": "{record.key}"
                },
                "question": {
                  "en": "Show the links between the people, phones and vehicles in case {record.key}",
                  "ar": "اعرض الروابط بين الأشخاص والهواتف والمركبات في القضية {record.key}"
                }
              },
              {
                "id": "similar",
                "label": {
                  "en": "Similar cases",
                  "ar": "قضايا مشابهة"
                },
                "agent": "moi-similar-cases",
                "input": {
                  "case_no": "{record.key}"
                },
                "question": {
                  "en": "Find cases similar to {record.key}",
                  "ar": "ابحث عن قضايا مشابهة للقضية {record.key}"
                }
              },
              {
                "id": "ask",
                "label": {
                  "en": "Ask about this case",
                  "ar": "اسأل عن هذه القضية"
                },
                "agent": "moi-case-qa",
                "input": {
                  "case_no": "{record.key}"
                },
                "question": {
                  "en": "Question about case {record.key}",
                  "ar": "سؤال عن القضية {record.key}"
                },
                "chat": true
              },
              {
                "id": "court-file",
                "label": {
                  "en": "Draft court file",
                  "ar": "مسودة ملف المحكمة"
                },
                "agent": "moi-court-file-draft",
                "input": {
                  "case_no": "{record.key}"
                },
                "question": {
                  "en": "Draft the court file for case {record.key}",
                  "ar": "اكتب مسودة ملف المحكمة للقضية {record.key}"
                }
              }
            ]
          }
        }
      ],
      "actions": [
        {
          "id": "request-detention",
          "label": {
            "en": "Request detention",
            "ar": "طلب توقيف"
          },
          "agent": "moi-detention-request",
          "input": {
            "emirates_id": "{record.key}",
            "station": "{user.unit}"
          }
        },
        {
          "id": "execute-order",
          "label": {
            "en": "Execute order",
            "ar": "تنفيذ الأمر"
          },
          "agent": "moi-judicial-orders",
          "call": {
            "tool": "moi",
            "action": "execute_order"
          },
          "input": {
            "order_no": "{record.key}",
            "station": "{user.unit}"
          },
          "roles": [
            "case-supervisor"
          ]
        },
        {
          "id": "open-court-file",
          "label": {
            "en": "Open court file",
            "ar": "فتح ملف المحكمة"
          },
          "agent": "moi-court-liaison",
          "input": {
            "reference": "{record.key}"
          }
        }
      ],
      "alerts": {
        "roles": [
          "case-supervisor",
          "case-worker"
        ]
      }
    }
  ]
}
